import { ChangeDetectorRef, Component, ComponentFactoryResolver, Injector, OnInit, ViewChild, ViewContainerRef, OnDestroy } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

import * as Constants from "../../../constants/constants";
import { ApiService } from 'src/app/services/api/api.service';
import { TabControlService } from 'src/app/services/tab-control.service';
import { environment } from 'src/environments/environment';
import { CurrencyPipe } from '@angular/common';
import { delay, extractKeys, extractNumericValue, formatDate, generatePDF, generateRandomNumber5 } from 'src/app/util/Helper';
import { createAmountAbove5KValidator } from 'src/app/services/validators/custom.validators';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from 'src/app/services/notification.service';
import { PDFService } from 'src/app/services/PDF/pdfservice.service';
import { GrantLetterComponent } from 'src/app/util/PDF/grant-letter/grant-letter.component';
import { Subscription, timer } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { CardsComponent } from 'src/app/components/cards/cards.component';
import { ValidationService } from '../../../services/validators/validation.service';

@Component({
  selector: 'app-step7-payment',
  templateUrl: './step7-payment.component.html',
  styleUrls: ['./step7-payment.component.scss']
})
export class Step7PaymentComponent implements OnInit, OnDestroy {
  @ViewChild('cardsComponent') cardsChild!: CardsComponent;
  
  private grantLetterComponent: GrantLetterComponent | null = null;
  private readonly abortController = new AbortController();

  PaymentModeOptions: any = [
    'M-Pesa Express (STK Push)',
    'M-Pesa Paybill',
    'Cash Deposits/Bank Transfer',
    // 'Direct Card Payment'
  ];
  BranchPlaceHolders: any = [];

  title: string = 'Make your initial capital deposit';

  paymentModeLabel: string = 'Preferred Mode of Payment';
  phoneLabel: string = 'M-Pesa Phone Number';
  investmentAmountLabel: string = 'Initial Investment Amount';
  investmentAmountHint: string = 'Enter initial investment amount';
  investmentAmountSubtext: string = 'The minimum amount should be Kes 5,000';

  bankLabel: string = 'Bank Name';
  bankHint: string = 'Select Bank';

  bankBranchLabel: string = 'Bank Branch';
  bankBranchHint: string = 'Select Bank Branch';

  accNameLabel: string = 'Account Name';
  accNameHint: string = 'Enter Account Name';

  accLabel: string = 'Account Number';
  accHint: string = 'Enter Account Number';

  receiptLabel: string = 'Existing M-PESA Receipt (Optional)';
  receiptHint: string = 'Confirm using M-Pesa Transaction Receipt if available';

  uploadSlipLabel: string = 'Upload Bank Slip/Remittance Advice';

  instructionsTitle: string = 'M-Pesa Express Payment Instructions';
  instructionsTitle2: string = 'M-Pesa Paybill Payment Instructions';

  instructionsTitleBank: string = 'ICEA LION Trust Co. Bank Deposit/Transfer Details';
  inst1: string = 'Enter your phone number and the amount you wish to pay';
  inst2: string = 'You will receive a Popup from M-Pesa on your Phone';
  inst2X: string = 'Enter your M-Pesa PIN to complete the payment on your Phone';
  inst3: string = 'You will receive a notification on your email once your transaction is complete';
  
  inst4: string = 'Go to Lipa Na M-Pesa Menu on your Phone';
  inst5: string = 'Use Paybill Business number: ';
  inst6: string = 'Use Account number: ';
  inst8: string = 'Pay and wait at least 2 minutes for the Payment to be detected and confirmed automatically';

  iceaFundLabel: string = 'Fund';
  iceaAcc: string = 'Account Number';
  iceaBank: string = 'Bank';
  iceaBranch: string = 'Branch';
  iceaBankCode: string = 'Bank Code';
  iceaBranchCode: string = 'Branch Code';
  iceaClearing: string = 'Clearing';

  iceaFundNameVal  : string = Constants.ICEA_FUND_NAME;
  iceaAccountVal : string = Constants.MILELE_ACCOUNT_NUM;
  iceaBankVal : string = Constants.ICEA_BANK;
  iceaBranchVal : string = Constants.ICEA_BANK_BRANCH;
  iceaBankCodeVal : string = Constants.ICEA_BANK_CODE;
  iceaBranchCodeVal : string = Constants.ICEA_BRANCH_CODE;
  iceaClearingVal : string = Constants.ICEA_CLEARING;
  iceaPaybill : number = Constants.PAYBILL_TRUST;

  requiredFieldString: string = 'Required field';

  loadingBanks: boolean = false;
  loadingBankBranches: boolean = false;

  loading: boolean = false;
  buttonText: string = 'Please Wait';

  banksEmpty: boolean = true;
  bankBranchesEmpty: boolean = true;

  ccEmails: any = [];

  telcoRef: string = '';
  grantLetter: string = '';

  countdownMPESA: number = 180;
  private timerSubscription: Subscription | null = null;

  formErrors: { [key: string]: string } = {
    PaymentMode: '',
    amount: '',
    phone: '',
    bank: '',
    bankBranch: '',
    accName: '',
    acc: '',
    slipDoc: '',
    email: '',
    receipt: ''
  };
  validationMessages: { [key: string]: {} } = {
    PaymentMode: { required: this.requiredFieldString },
    amount: { required: this.requiredFieldString, cMin:'Invalid amount' },
    phone: { required: this.requiredFieldString, invalid:'Invalid phone number' },
    bank: { required: this.requiredFieldString },
    bankBranch: { required: this.requiredFieldString },
    accName: { required: this.requiredFieldString },
    acc: { required: this.requiredFieldString },
    slipDoc: { required: this.requiredFieldString },
    email: { required: this.requiredFieldString, email: "Invalid email address" },
    receipt: { required: this.requiredFieldString },
  };

  // Form
  paymentForm = this._formBuilder.group({
    PaymentMode: [this.PaymentModeOptions[0], Validators.required],
    amount: ['', [Validators.required, createAmountAbove5KValidator()]],
    phone: ['', Validators.required],
    
    bank: [{value: '', disabled: true}],
    bankBranch: [{value: '', disabled: true}],
    accName: [''],
    acc: [''],
    slipDoc: [],

    receipt: [''],

    // Card controls
    Currency: [''],
    CardNumber: [''],
    CVV: [''],
    Expiry: [''],
    CardName : ['']
  });

  amountRaw: number = 0;

  constructor(
    private readonly _formBuilder: FormBuilder,
    private readonly validationService: ValidationService,
    private readonly apiService: ApiService,
    private readonly notificationService: NotificationService,
    private readonly tabControlService: TabControlService,
    private readonly router: Router,
    private readonly viewContainerRef: ViewContainerRef,
    private readonly componentFactoryResolver: ComponentFactoryResolver,
    private readonly injector: Injector,
    private readonly pdfService: PDFService,
    private readonly cdr: ChangeDetectorRef,
    private readonly currencyPipe: CurrencyPipe,
    private readonly route: ActivatedRoute
  ) {
  }

  ngOnInit(): void {
    if (this.BanksOptions.length === 0 && this.tabControlService.activeTab == 7)  {this.getBanksList()}
    else {this.paymentForm.get('bank')?.enable()}

    this.destroyGrantLetterComponent();
    if (this.settlors && this.settlors.length > 0) {
      if (this.settlorType === 0) {
        if (this.settlors.Authorisers && this.settlors.Authorisers.length > 0) {
          for (const element of this.settlors.Authorisers) {
            const item = {
              FirstName: element.FirstName,
              Email: element.Email,
              Phone: element.Phone
            };

            this.ccEmails.push(item);
          }
        }
      
      } else {  // Remove this section if normal settlors should not receive this email
        for (let i=1; i<this.settlors.length; i++) {
          const item = {
            FirstName: this.settlors[i].FirstName,
            Email: this.settlors[i].Email,
            Phone: this.settlors[i].Phone
          };

          this.ccEmails.push(item);
        }
      }   
    }

    if (this.paymentData === false && Object.keys(this.paymentData).length === 0) {
      let paymentId = `MIL-${this.tabControlService.basicData.IDNo}-${generateRandomNumber5()}`.toLowerCase();

      if (this.tabControlService.settlorType == 1) {
        paymentId = `MIL-${this.tabControlService.basicData.IDNo}-${generateRandomNumber5()}`.toLowerCase();
      }
      this.tabControlService.paymentID = paymentId;
    } else {
      this.paymentForm.patchValue({
        PaymentMode: this.paymentData.amount > 0 && this.paymentData.PaymentMode ? this.paymentData.PaymentMode : this.PaymentModeOptions[0],
        amount: this.paymentData.amount.toString() || '',
        phone: this.paymentData.phone || '',
        accName: this.paymentData.accName || '',
        acc: this.paymentData.acc || '',
        // Card controls
        Currency: this.paymentData.Currency || '',
        CardNumber: this.paymentData.CardNumber || '',
        CVV: this.paymentData.CVV || '',
        Expiry: this.paymentData.Expiry || '',
        CardName : this.paymentData.CardName || ''
      });
      
      if (this.paymentData.PaymentMode === this.PaymentModeOptions[3]) { // CARD
        this.validationService.addOrRemoveValidator(true, this.paymentForm.get('Currency')!);
        this.validationService.addOrRemoveValidator(true, this.paymentForm.get('CardNumber')!);
        this.validationService.addOrRemoveValidator(true, this.paymentForm.get('CVV')!);
        this.validationService.addOrRemoveValidator(true, this.paymentForm.get('Expiry')!);
        this.validationService.addOrRemoveValidator(true, this.paymentForm.get('CardName')!);

        this.validationService.addOrRemoveValidator(false, this.paymentForm.get('phone')!);
        this.paymentForm.get('phone')?.setValue('');
        this.paymentForm.get('receipt')?.setValue('');
        this.validationService.addOrRemoveValidator(false, this.paymentForm.get('bank')!);
        this.validationService.addOrRemoveValidator(false, this.paymentForm.get('bankBranch')!);
        this.validationService.addOrRemoveValidator(false, this.paymentForm.get('accName')!);
        this.validationService.addOrRemoveValidator(false, this.paymentForm.get('acc')!);
        this.validationService.addOrRemoveValidator(false, this.paymentForm.get('slipDoc')!);

        this.paymentForm.get('bank')?.setValue('');
        this.paymentForm.get('bankBranch')?.setValue('');
        this.paymentForm.get('accName')?.setValue('');
        this.paymentForm.get('acc')?.setValue('');
        this.paymentForm.get('slipDoc')?.setValue(null);

      } else if (this.paymentData.PaymentMode == this.PaymentModeOptions[2]) { // banks
        this.resetTimer();
        this.validationService.addOrRemoveValidator(true, this.paymentForm.get('bank')!);
        this.validationService.addOrRemoveValidator(true, this.paymentForm.get('bankBranch')!);
        this.validationService.addOrRemoveValidator(true, this.paymentForm.get('accName')!);
        this.validationService.addOrRemoveValidator(true, this.paymentForm.get('acc')!);
        this.validationService.addOrRemoveValidator(true, this.paymentForm.get('slipDoc')!);

        this.validationService.addOrRemoveValidator(false, this.paymentForm.get('phone')!);
      }
    }

    this.paymentForm.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged((prev, curr) => prev.amount === curr.amount)
    ).subscribe((form) => {
      this.logErrors();

      if (form.amount) {
        // Store raw numeric value first
        const rawNumeric = extractNumericValue(form.amount);
        const numericAmount = Number(rawNumeric);
        
        // Only format for display, don't re-parse
        const displayAmount = this.currencyPipe.transform(
          rawNumeric,  // Use the extracted numeric string, not the formatted one
          'KSH ', 
          'symbol', 
          '1.0-0'
        );
        // Only update if the display format is different
        if (displayAmount !== form.amount) {
          this.paymentForm.patchValue({
            amount: displayAmount
          }, {emitEvent: false});
        }
        this.amountRaw = numericAmount;
      }
    });

    this.paymentForm.valueChanges
    .pipe(debounceTime(400))
    .subscribe(()=> {
      this.updatePaymentDetails();
    });

    this.paymentForm.get('PaymentMode')?.valueChanges.subscribe((data) => {
      if (data === this.PaymentModeOptions[3]) {
        this.resetTimer();
        this.validationService.addOrRemoveValidator(true, this.paymentForm.get('Currency')!);
        this.validationService.addOrRemoveValidator(true, this.paymentForm.get('CardNumber')!);
        this.validationService.addOrRemoveValidator(true, this.paymentForm.get('CVV')!);
        this.validationService.addOrRemoveValidator(true, this.paymentForm.get('Expiry')!);
        this.validationService.addOrRemoveValidator(true, this.paymentForm.get('CardName')!);

        this.validationService.addOrRemoveValidator(false, this.paymentForm.get('phone')!);
        this.paymentForm.get('phone')?.setValue('');
        this.paymentForm.get('receipt')?.setValue('');
        this.validationService.addOrRemoveValidator(false, this.paymentForm.get('bank')!);
        this.validationService.addOrRemoveValidator(false, this.paymentForm.get('bankBranch')!);
        this.validationService.addOrRemoveValidator(false, this.paymentForm.get('accName')!);
        this.validationService.addOrRemoveValidator(false, this.paymentForm.get('acc')!);
        this.validationService.addOrRemoveValidator(false, this.paymentForm.get('slipDoc')!);

        this.paymentForm.get('bank')?.setValue('');
        this.paymentForm.get('bankBranch')?.setValue('');
        this.paymentForm.get('accName')?.setValue('');
        this.paymentForm.get('acc')?.setValue('');
        this.paymentForm.get('slipDoc')?.setValue(null);
        
      } else if (data === this.PaymentModeOptions[2]) {
        this.resetTimer();
        this.validationService.addOrRemoveValidator(true, this.paymentForm.get('bank')!);
        this.validationService.addOrRemoveValidator(true, this.paymentForm.get('bankBranch')!);
        this.validationService.addOrRemoveValidator(true, this.paymentForm.get('accName')!);
        this.validationService.addOrRemoveValidator(true, this.paymentForm.get('acc')!);
        this.validationService.addOrRemoveValidator(true, this.paymentForm.get('slipDoc')!);

        this.validationService.addOrRemoveValidator(false, this.paymentForm.get('phone')!);
        this.paymentForm.get('phone')?.setValue('');
        this.paymentForm.get('receipt')?.setValue('');

        if (this.BanksOptions.length === 0) this.getBanksList();
        else this.paymentForm.get('bank')?.enable()
        
      } else {
        this.validationService.addOrRemoveValidator(true, this.paymentForm.get('phone')!);

        this.validationService.addOrRemoveValidator(false, this.paymentForm.get('bank')!);
        this.validationService.addOrRemoveValidator(false, this.paymentForm.get('bankBranch')!);
        this.validationService.addOrRemoveValidator(false, this.paymentForm.get('accName')!);
        this.validationService.addOrRemoveValidator(false, this.paymentForm.get('acc')!);
        this.validationService.addOrRemoveValidator(false, this.paymentForm.get('slipDoc')!);

        if (data === this.PaymentModeOptions[1]) { // M-PESA PAYBILL
          this.validationService.addOrRemoveValidator(false, this.paymentForm.get('phone')!);
          this.paymentForm.get('phone')?.setValue('');

          this.startCheckPaymentTimer();
        } else {
          this.resetTimer();
          this.paymentForm.get('receipt')?.setValue('');
          this.validationService.addOrRemoveValidator(true, this.paymentForm.get('phone')!);
        }

      }
    });

    this.route.queryParams.subscribe((params) => {
      // Handle cards
      const intentId = params['intentId'];
      const action = params['action'];
      
      if (intentId && action?.toLowerCase() === 'make_payment') {
        // Force the layout context to reflect Direct Card Payment mode
        this.paymentForm.get('PaymentMode')?.setValue(this.PaymentModeOptions[3]);
        
        // Run validation check specifically for the card section inputs
        const cardControls = ['Currency', 'CardNumber', 'CVV', 'Expiry', 'CardName'];
        let isCardFormValid = true;

        cardControls.forEach(controlName => {
          const control = this.paymentForm.get(controlName);
          if (control) {
            control.updateValueAndValidity();
            if (control.invalid) {
              isCardFormValid = false;
            }
          }
        });
        if (isCardFormValid) {
          this.notificationService.isLoading(true);
          this.notificationService.viewToast('info', 'Processing card payment...');

          // Update the payment tracking state internally beforehand
          this.tabControlService.stkRequestID = intentId;

          // Directly ping the process payment endpoint using the returned reference identifier
          this.apiService.getRequest(`${environment.baseUrl}${Constants.processCardPaymentURL}?ref=${intentId}`)
            .then(async (response: any) => {
              if (response.Status === 1 && response.Data?.status === 'COMPLETED') {
                this.notificationService.viewToast('success', 'Card payment received');
                
                // Finalize locally saved storage definitions
                await this.updatePaymentDetails();
                // Commit updates to server configuration mappings
                await this.updateTrustDetails('CARD');
              } else {
                this.notificationService.viewToast('error', 'Payment confirmation failed', response.Message || 'Please try again.');
                this.notificationService.isLoading(false);
              }
            })
            .catch((error: any) => {
              console.error('Failed to process redirected card payment:', error);
              this.notificationService.viewToast('error', 'An error occurred', 'Could not complete payment verification');
              this.notificationService.isLoading(false);
            });
        } else {
          this.notificationService.viewToast('warning', 'Card parameters are invalid or missing from session cache.');
          this.logErrors();
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.stopTimer();
    // Abort all ongoing requests when the component is destroyed
    this.abortController.abort();
  }

  get settlors(): any {
    return this.tabControlService.settlors;
  }

  get regionType(): number {
    return this.tabControlService.regionType;
  }
  get settlorType(): number {
    return this.tabControlService.settlorType;
  }

  get BanksOptions(): any {
    return this.tabControlService.BanksOptions;
  }
  get stkLoading(): boolean {
    return this.tabControlService.stkLoading;
  }

  get paymentID(): string {
    return this.tabControlService.paymentID;
  }

  get paymentData(): any {
    return this.tabControlService.paymentData;
  }

  get summary(): string {
    return this.tabControlService.summary;
  }
  slipObject: any = null;

  get saveProgress(): ()=> void {
    return this.tabControlService.saveProgress;
  }

  startCheckPaymentTimer(): void {
    this.resetTimer();

    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }

    this.timerSubscription = timer(0, 1000).subscribe((elapsedTime) => {
      if (this.countdownMPESA > 0) {
        this.countdownMPESA--;
      } else {
        this.timerSubscription?.unsubscribe();
        this.confirmPaybillPayment(10);
      }
    });
  }
  async updatePaymentDetails() {
    const rawAmount = extractNumericValue(this.paymentForm.value.amount);
    const numericAmount = Number(rawAmount);
    
    // Attempt to validate no extra zero(s) was added
    const expectedLength = rawAmount.replace(/^0+/, '').length;
    const actualLength = this.amountRaw.toString().length;
    
    if (Math.abs(actualLength - expectedLength) > 2) { // Suspicious length change
      console.warn('Potential amount multiplication detected', {
        raw: rawAmount,
        current: this.amountRaw,
        formValue: this.paymentForm.value.amount
      });
    }
    if (numericAmount !== this.amountRaw) {
      this.amountRaw = numericAmount;
    }
    
    const details = {
      ...this.paymentForm.getRawValue(),
      amount: numericAmount,
      receipt: this.telcoRef
    };
    await this.tabControlService.updateRecord(7, details);
  }

  stopTimer(): void {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
      this.timerSubscription = null;
    }
  }

  resetTimer(): void {
    this.stopTimer();
    this.countdownMPESA = 180;
  }

  async getBanksList() {
    this.loadingBanks = true;

    const response = await this.tabControlService.getBanksList();
    if (response === 1) {
      this.paymentForm.get('bank')?.enable();
      this.banksEmpty = false;
    } else {
      this.banksEmpty = true;
    }
    this.loadingBanks = false;
  }

  async populateBankBranchesList() {
    this.loadingBankBranches = true;
    this.BranchPlaceHolders = [];
    
    try {
      const bankValue = this.paymentForm.get('bank')?.value;
  
      if (!(bankValue === null || bankValue ==='' || bankValue === undefined)) {
        
        const branchRequest = {
          BankID: `${bankValue}`,
        };
        const response = await this.apiService.postRequest(
          environment.baseUrl + Constants.bankBranchesURL,
          branchRequest
        );

        if (response.Status === 1) {
          const sortedData = response.Data.sort((a: any, b: any) => {
            return a.Description.localeCompare(b.Description);
          });
          this.BranchPlaceHolders = sortedData;
          this.paymentForm.get('bankBranch')?.enable();
          this.bankBranchesEmpty = false;
        } else {
          console.log('>>> Error !! ', response.Message);
          this.bankBranchesEmpty = true;
        }
        this.loadingBankBranches = false;
      }
    } catch(error) {
      console.log('>>> Error !! ', error);
    }
    this.loadingBankBranches = false;
  }

  logErrors() {
    this.formErrors = this.validationService.logValidationErrors(
      this.paymentForm,
      this.formErrors,
      this.validationMessages
    );
  }

  updateSlipObject(object: any): void {
    this.slipObject = object;
  }

  async createGrantLetterComponent(): Promise<void> {
    try {
      this.destroyGrantLetterComponent();
      this.viewContainerRef.clear();
      
      // Force change detection and Add a small delay to ensure cleanup is complete
      this.cdr.detectChanges();
      await new Promise(resolve => setTimeout(resolve, 50));
  
      // Create component
      const componentFactory = this.componentFactoryResolver.resolveComponentFactory(GrantLetterComponent);
      const componentRef = this.viewContainerRef.createComponent(componentFactory, 0, this.injector);
      this.grantLetterComponent = componentRef.instance;
  
      // Set payment amount
      // Use the numeric value directly for the grant letter
      this.grantLetterComponent.paymentAmount = `KSH ${this.amountRaw}`;
  
      // Wait for paymentAmount to be ready
      await this.grantLetterComponent.waitForPaymentAmount();
  
      // Trigger change detection
      this.cdr.detectChanges();
  
      // Wait for component to initialize
      await new Promise(resolve => setTimeout(resolve, 50));
  
      // Get PDF content
      const pdfGrantContent = await this.pdfService.waitForPdfGrantContent();
      if (!pdfGrantContent) throw new Error('PDF content not available');
  
      // Double-check rendering
      this.cdr.detectChanges();
      await new Promise(resolve => requestAnimationFrame(resolve));
  
      // Generate PDF
      this.grantLetter = await generatePDF(pdfGrantContent.nativeElement, 'Grant Letter');
      if (!environment.production) {
        console.log('Generated PDF with amount:', this.grantLetterComponent.paymentAmount, '\n');
        console.log(this.grantLetter);
      }
  
      this.destroyGrantLetterComponent();
    } catch (error) {
      console.error('Error creating grant letter:', error);
      this.notificationService.viewToast('error', 'Failed to generate grant letter');
      throw error; // Re-throw to handle in calling function
    }
  }

  destroyGrantLetterComponent = () => {
    if (this.grantLetterComponent) {
      // Clear the PDF service state
      this.pdfService.setGrantPdfContent(null);
      
      // Destroy component
      this.viewContainerRef.clear();
      this.grantLetterComponent = null;
      
      // Force change detection
      this.cdr.detectChanges();
      if (!environment.production) console.log('Grant PDF cleared');
    }
  };

  cancelApiCall() {
    // Abort the ongoing request manually
    this.abortController.abort();
    if (!environment.production) console.log('API call canceled');
  }

  async confirmPaybillPayment(attempts?: number): Promise<void> {
    if (attempts == 1) this.notificationService.isLoading(true);

    await this.updatePaymentDetails();
    this.tabControlService.updateSTK(this.paymentID, 'Amount via Paybill', this.paymentForm.value.phone as string);

    let finalAttempts = attempts;
    if (!attempts) {
      this.notificationService.viewToast('info', 'Checking for M-Pesa Payment');
      this.notificationService.isLoading(true);
      finalAttempts = 5;
    }

    await this.retryMpesaPaymentConfirmation(finalAttempts)
    .then(async (result) => {
      this.notificationService.isLoading(false);

      if (result.Status === 1) {
        this.amountRaw = result.Amount;
        this.paymentForm.patchValue({
          amount: result.Amount
        }, {emitEvent: false});

        this.telcoRef = result.Reference;
        await this.updatePaymentDetails();
        this.notificationService.viewToast('info', 'Payment received');
        
        await this.updateTrustDetails('MPESA Paybill');
        
      } else if (result.Status === 2) {
        this.notificationService.viewToast('error', 'Could not confirm your payment');
      } else {
        // Error occurred!!
        this.notificationService.viewToast('error', 'Transaction not confirmed', result.Message);
      }
      
    })
    .catch((error) => {
      this.notificationService.isLoading(false);
      console.error('confirmPaybillPayment:', error);
      this.notificationService.viewToast('error', 'An unexpected error occurred');
    });
  }
  
  async mpesaPayment(): Promise<void> {
    if (this.paymentForm.invalid) {
      this.notificationService.viewToast('warning', 'Please fill in the payment details first');
      return;
    }
    await this.updatePaymentDetails();

    this.notificationService.isLoading(true);
    this.buttonText = 'Please Wait';
    this.loading = true;
    try {
      const nakedAmount = environment.production ? this.amountRaw.toString() : '1' ;

      const data = {
        Amount: nakedAmount,
        Phone: this.paymentForm.value.phone,
        BillRefNo: this.paymentID,
        TrustName: this.tabControlService.trustInfo.TrustName,
      };

      const response = await this.apiService.postRequest(
      environment.baseUrl + Constants.mpesaPaymentURL, data);

      if (response.Status === 1) {
        this.notificationService.viewToast('info', 'M-Pesa Payment requested');
        
        this.tabControlService.updateSTK(this.paymentID, nakedAmount, this.paymentForm.value.phone as string);
        this.tabControlService.stkPinText = this.tabControlService.stkDefPinText;
        this.loading = false;
        this.notificationService.isLoading(false);
        this.tabControlService.stkLoading = true;

        await delay(30000);

        await this.retryMpesaPaymentConfirmation()
        .then(async (result) => {
          if (result.Status === 1) {
            this.telcoRef = result.Reference;
            await this.updatePaymentDetails();
            this.notificationService.viewToast('success', 'Payment received');
            this.tabControlService.stkLoading = false;

            await this.updateTrustDetails('MPESA Express');
            
          } else if (result.Status === 2) {
            this.notificationService.viewToast('error', 'Could not confirm your payment');
            this.tabControlService.stkTimeout = true;
            
          } else {
            // Error occurred!!
            this.notificationService.viewToast('error', result.Message);

            this.tabControlService.stkTimeout = true;
          }
          
        })
        .catch((error) => {
          console.error('Error:', error);
          this.notificationService.viewToast('error', 'An unexpected error occurred');
        }); 
      } else {
        this.loading = false;
        this.notificationService.isLoading(false);
        this.notificationService.viewToast('error', response.Message);
      }
    } catch (error) {
      this.loading = false;
      this.notificationService.isLoading(false);
      console.error(':: mpesaPayment !! ', error);
    } finally {
      this.tabControlService.stkLoading = false;
    }
  }

  async retryMpesaPaymentConfirmation(maxAttempts: number = 5): Promise<any> {
    let attempts = 0;

    const confirmMpesaPayment = async (): Promise<any> => {
      try {
        const receiptCode = this.paymentForm.get('receipt')?.value;

        if (receiptCode && receiptCode.length > 5) this.tabControlService.reqPath = Constants.MPESA_RECEIPT_PATH;
        else this.tabControlService.reqPath = Constants.MPESA_BILL_PATH;

        let phone = this.paymentForm.get('phone')?.value;
        if (phone == null || phone == undefined || phone == '') phone = this.tabControlService.basicData.Phone;

        const data = {
          PaymentID: this.paymentID,
          Phone:  phone,
          RequestPath: this.tabControlService.reqPath,
          BillRefNo: receiptCode && receiptCode.length > 5 ? receiptCode : this.paymentID,
        };
  
        const response = await this.apiService.postRequest(
          environment.baseUrl + Constants.confirmMPESAPaymentURL, 
          data, 
          true, 
          'application/json', 
          this.abortController.signal // Pass the AbortSignal here
        );
  
        if (response && response.Status) {
          return response;
        } else {
          return {
            Status: 0,
            Message: 'Error contacting server'
          };
        }
      } catch (error) {
        let resp = {
          Status: 0,
          Message: 'An unexpected error occurred'
        }
        console.error(':: M-Pesa Confirmation !! ', error);
        return resp;
      }
    }
  
    async function tryConfirmation() {
      attempts++;
      if (!environment.production) console.log(`Attempt ${attempts}`);
  
      const response = await confirmMpesaPayment();
  
      if (response.Status === 1) {
        return response;
      } else if (response.Status === 2) {
        if (attempts < maxAttempts) {
          await delay(10000); // Wait for 15 seconds
          return tryConfirmation();
        } else {
          return {
            Status: 2,
            Message: 'Max retry attempts reached'
          };
        }
      } else {
        return {
          Status: 0,
          Message: response.Message
        };
      }
    }
  
    return tryConfirmation();
  }

  async rtgsPayment(): Promise<void> {
    await this.updatePaymentDetails();
    this.updateTrustDetails('RTGS');
  }
  
  // Initial trigger method called by submitForm() routing logic
  async directCardPayment(): Promise<void> {
    // Safely cache form details beforehand
    await this.updatePaymentDetails();
    // Kickstart the multi-step card processing engine inside the child component
    await this.cardsChild.createPaymentIntent();
  }
  // Success Callback handler hooked to Cards child component output listener
  async onCardPaymentSuccess(): Promise<void> {
    // This runs ONLY when the transaction states turn into 'COMPLETED'
    await this.updateTrustDetails('CARD');
  }

  async updateTrustDetails(paymentMode: string): Promise<void> {
    this.tabControlService.stkLoading = false;
    this.notificationService.isLoading(true);
    this.buttonText = 'Please Wait';
    this.loading = true;

    try {
      const grantLetter = await this.generateGrantLetter();

      if (grantLetter === 'error') {
        this.notificationService.viewToast('error', 'Failed to generate grant letter', 'Please try again later');
        this.notificationService.isLoading(false);
        this.loading = false;
        return;
      }

      this.grantLetter = grantLetter;
      const excelFile = this.generateExcelFileJSON();
      if (excelFile == 'error') {
        this.notificationService.viewToast('error', 'A critical error occurred');
        return;
      }

      let url = Constants.mpesaCompleteURL;
      let data = {
        PaymentMode: paymentMode,

        Amount: this.amountRaw.toString(),
        Name: this.tabControlService.basicData.FirstName,
        Email: this.tabControlService.basicData.Email,
        Phone: this.tabControlService.basicData.Phone,
        CCEmails: this.ccEmails,
        Summary: this.summary,
        GrantLetter: this.grantLetter,
        Docs: this.tabControlService.docSummary,
        ExcelData: excelFile,
        TrustName: this.tabControlService.trustInfo.TrustName.replace(' ', '-'),
        TrustID: this.tabControlService.TrustID
      };

      if (paymentMode == 'RTGS') {
        url = Constants.rtgsPaymentURL;
        data = {
          ...data,
          ...{
            BankName: this.paymentForm.value.bank,
            BankBranch: this.paymentForm.value.bankBranch,
            AccountName: this.paymentForm.value.accName,
            AccountNo: this.paymentForm.value.acc,
            BankSlipUrl: this.slipObject,
          }
        };
      } else if (paymentMode.includes('MPESA')) {
        data = {
          ...data,
          ...{
            Phone: this.paymentForm.value.phone,
            MpesaAmount: this.amountRaw,
            Telcoref: this.telcoRef
          }
        };
      }

      const response = await this.apiService.postRequest(
        environment.baseUrl + url, data);

      if (response.Status === 1) {
        this.notificationService.viewToast('success', 'Payment details received');
        this.navigate();

      } else {
        this.notificationService.viewToast('error', response.Message);
      }

      this.notificationService.isLoading(false);
      this.loading = false;

    } catch (error) {
      console.error(':: Error !! ', error);
      this.notificationService.viewToast('error', 'An unexpected error occurred');
      this.notificationService.isLoading(false);
      this.loading = false;
    }
  }


  async generateGrantLetter(): Promise<string> {
    let grantLetter = 'error';

    try {
      const data = {
        RegionType: this.regionType,
        TrustID: this.tabControlService.TrustID,
        PaymentAmount: this.amountRaw.toString(),
        SettlorType: this.settlorType,
        Settlors: extractKeys(this.tabControlService.settlors, ['Title', 'FirstName', 'MiddleName', 'LastName', 'Address', 'Phone', 'Email', 'Country']),
        Beneficiaries: extractKeys(this.tabControlService.beneficiaries, ['Category', 'FirstName', 'MiddleName', 'LastName', 'InstitutionName', 'PercShare', 'TrustPurpose', 'OtherPurpose']),
        Guardians: extractKeys(this.tabControlService.guardians, ['Category', 'FirstName', 'MiddleName', 'LastName', 'IDNo', 'Phone', 'Email']),
        TrustInfo: {
          TrustName: this.tabControlService.trustInfo.TrustName,
          TerminationAge: this.tabControlService.trustInfo.TerminationAge,
          DistributionAge: this.tabControlService.trustInfo.DistributionAge,
          UpkeepFrequency: this.tabControlService.trustInfo.UpkeepFrequency,
          UpkeepAmount: this.tabControlService.trustInfo.UpkeepAmount,
          SourceOfFunds: this.tabControlService.trustInfo.SourceOfFunds,
          OtherSource: this.tabControlService.trustInfo.OtherSource || '',
        },
        SignatureImage: this.tabControlService.signatureImage,
      };

      const response = await this.apiService.postRequest(
        `${environment.baseUrl}${Constants.grantLetterURL}`, data);

      if (response.Status === 1 && response?.URL != '') {
        this.notificationService.viewToast('success', 'Payment details received');
        grantLetter = response.URL;
      } else {
        this.notificationService.viewToast('error', response.Message);
      }
    } catch (error) {
      console.error('Error generating grant letter:', error);
    }
    return grantLetter;
  }

  generateExcelFileJSON(): string {
    let formattedData = this.tabControlService.stripSavedObjects(this.tabControlService.storageObject);
    formattedData = this.processObject(formattedData);
    
    let formattedAuthorisers = null;
    let formattedContactPersons: any = [];
    let formattedGuardianBens: any = [];

    if (formattedData.basicData.hasOwnProperty('Verified')) {
      delete formattedData.basicData['Verified'];
    }

    // Settlors
    if (this.settlorType == 0 && formattedData.settlors[0].Authorisers) {
      formattedAuthorisers = formattedData.settlors[0].Authorisers;

      if (formattedData.settlors[0].hasOwnProperty('Authorisers')) {
        delete formattedData.settlors[0]['Authorisers'];
      }
    }
    for (const element of formattedData.settlors) {
      if (element.hasOwnProperty('infoDone')) {
        delete element['infoDone'];
      }
      if (element.hasOwnProperty('verified')) {
        delete element['verified'];
      }
      if (element.hasOwnProperty('authDone')) {
        delete element['authDone'];
      }
      if (element.hasOwnProperty('docsDone')) {
        delete element['docsDone'];
      }
      if (element.hasOwnProperty('done')) {
        delete element['done'];
      }
      if (element.hasOwnProperty('IDNoImage')) {
        delete element['IDNoImage'];
      }
      if (element.hasOwnProperty('KraPinImage')) {
        delete element['KraPinImage'];
      }
      if (element.hasOwnProperty('SavedID')) {
        delete element['SavedID'];
      }
      if (element.hasOwnProperty('SavedPIN')) {
        delete element['SavedPIN'];
      }

      if (this.tabControlService.settlorType === 1 && element.hasOwnProperty('Principal')) {
        delete element['Principal'];
      }
    }

    // Beneficiaries
    for (const element of formattedData.beneficiaries) {
      if (element.ContactPersons && element.ContactPersons.length > 0) {
        for (let belebent of element.ContactPersons) {
          let contact = belebent;
          contact = {...contact, 'Linked Beneficiary': element.BeneficiaryID };

          formattedContactPersons.push(contact);
        }
      }
      
      if (element.hasOwnProperty('ContactPersons')) {
        delete element['ContactPersons'];
      }
      if (element.hasOwnProperty('personalDone')) {
        delete element['personalDone'];
      }
      if (element.hasOwnProperty('contactsDone')) {
        delete element['contactsDone'];
      }
      if (element.hasOwnProperty('done')) {
        delete element['done'];
      }
      if (element.hasOwnProperty('IDNoImage')) {
        delete element['IDNoImage'];
      }
      if (element.hasOwnProperty('RegCertImage')) {
        delete element['RegCertImage'];
      }
      if (element.hasOwnProperty('BirthCertImage')) {
        delete element['BirthCertImage'];
      }
      if (element.hasOwnProperty('KraPinImage')) {
        delete element['KraPinImage'];
      }

      if (element.hasOwnProperty('SavedID')) {
        delete element['SavedID'];
      }
      if (element.hasOwnProperty('SavedPIN')) {
        delete element['SavedPIN'];
      }
      if (element.hasOwnProperty('SavedRegCert')) {
        delete element['SavedRegCert'];
      }
      if (element.hasOwnProperty('SavedBirthCert')) {
        delete element['SavedBirthCert'];
      }
      if (element.hasOwnProperty('DOB')) {
        const date = formatDate(element.DOB);
        element.DOB = date;
      }
    }
    if (formattedContactPersons.length === 0) {
      formattedContactPersons = null;
    }

    // Guardians
    for (const element of formattedData.guardians) {
      if (element.GuardianBens && element.GuardianBens.length > 0) {
        for (let velevent of element.GuardianBens) {
          let contact = velevent;

          contact.GuardianID = element.GuardianID;
          contact = {
            ...contact,
              GuardianName: `${element.FirstName} ${element.LastName}` 
             };

          if (contact.hasOwnProperty('BeneficiaryIDs')) {
            delete contact['BeneficiaryIDs'];
          }
          if (contact.hasOwnProperty('TrustID')) {
            delete contact['TrustID'];
          }
          if (contact.hasOwnProperty('ID')) {
            delete contact['ID'];
          }
          if (contact.hasOwnProperty('AccountType')) {
            delete contact['AccountType'];
          }
          formattedGuardianBens.push(contact);
        }
      }
      
      if (element.hasOwnProperty('GuardianBens')) {
        delete element['GuardianBens'];
      }

      if (element.hasOwnProperty('verified')) {
        delete element['verified'];
      }
      if (element.hasOwnProperty('done')) {
        delete element['done'];
      }
      if (element.hasOwnProperty('IDNoImage')) {
        delete element['IDNoImage'];
      }
      if (element.hasOwnProperty('KraPinImage')) {
        delete element['KraPinImage'];
      }

      if (element.hasOwnProperty('SavedID')) {
        delete element['SavedID'];
      }
      if (element.hasOwnProperty('SavedPIN')) {
        delete element['SavedPIN'];
      }
    }
    if (formattedGuardianBens.length === 0) {
      formattedGuardianBens = null;
    }

    if (formattedData.paymentData.hasOwnProperty('slipDoc')) {
      delete formattedData.paymentData['slipDoc'];
    }

    let excelData = {
      'Payment Details': formattedData.paymentData,
      'Personal Information': formattedData.basicData,
      'Settlors': formattedData.settlors, //array
      'Beneficiaries': formattedData.beneficiaries, //array
      'Guardians': formattedData.guardians, //array
      'Trust Information': formattedData.trustInfo,
    };

    if (formattedAuthorisers) {
      excelData = {...excelData, ...{'Settlor-Authorisers': formattedAuthorisers} };
    }
    if (formattedGuardianBens) {
      excelData = {...excelData, ...{'Beneficiary-Guardian-Link': formattedGuardianBens} };
    }
    if (formattedContactPersons) {
      excelData = {...excelData, ...{'Beneficiary-Contact-Persons': formattedContactPersons} };
    }

    try {
      return JSON.stringify(excelData);
    } catch (error) {
      console.error(error);
      return 'error';
    }
  }

  processObject(obj: any): any {
    // Check if the input is an array
    if (Array.isArray(obj)) {
      // If the array contains strings, join them with commas
      if (typeof obj[0] === 'string') {
          return obj.join(', ');
      }
      // If the array contains objects, process each object recursively
      else {
          return obj.map((item: any) => this.processObject(item));
      }
    }
    
    // If the input is an object, process its keys and values
    if (typeof obj === 'object' && obj !== null) {
      const result: any = {};
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          // Rename 'PercShare' to 'SharePercentage'
          const newKey = key === 'PercShare' ? 'SharePercentage' : key;
          // Recursively process nested objects or arrays
          result[newKey] = this.processObject(obj[key]);
        }
      }
      return result;
    }
    
    // If the input is neither an object nor an array, return it as is
    return obj;
  }

  async updateProgress(): Promise<void> {
    this.saveProgress();
  }

  navigate() {
    const nextPage = `milele-trust/success`;
    this.router.navigate([nextPage]);
  }

  async submitForm(): Promise<void> {
    if (this.paymentForm.value.PaymentMode === this.PaymentModeOptions[0]) {
      this.mpesaPayment();
    } else if (this.paymentForm.value.PaymentMode === this.PaymentModeOptions[1]) {
      this.confirmPaybillPayment(1);
    } else if (this.paymentForm.value.PaymentMode === this.PaymentModeOptions[3]) {
      if (this.cardsChild) {
        this.directCardPayment();
      } else {
        this.notificationService.viewToast('error', 'Unable to run cards logic');
        console.error('CardsComponent is not rendered or available yet.');
      }
    } else {
      this.rtgsPayment();
    } 
  }

}
